import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { ROUTES, CONTACT } from "./data";

const FLINKS = [
  { label: "Search Homes", href: ROUTES.idx },
  { label: "Buy a Home", href: ROUTES.buy },
  { label: "Get My Home Value", href: ROUTES.sell },
  { label: "Financing", href: ROUTES.financing },
  { label: "Areas We Serve", href: ROUTES.areas },
  { label: "Meet Our Agents", href: ROUTES.agents },
  { label: "Join Wallstreet Realty", href: ROUTES.join },
  { label: "Blog", href: ROUTES.blog },
  { label: "About", href: ROUTES.about },
  { label: "Contact", href: ROUTES.contact },
];

export const Footer = () => (
  <footer className="bg-[#254369] text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-heading font-extrabold text-2xl tracking-tight">
            Wallstreet<span className="text-[#C9A961]"> Realty</span>
          </div>
          <p className="mt-3 text-sm text-white/70 leading-relaxed">
            Southern California Real Estate and Mortgage Brokerage.
          </p>
          <p className="mt-2 text-sm text-white/70">{CONTACT.broker} · {CONTACT.dre}</p>
          <p className="mt-4 flex items-start gap-2 text-sm text-white/70 leading-relaxed">
            <MapPin size={15} className="mt-0.5 shrink-0 text-[#C9A961]" />
            {CONTACT.address}
          </p>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#C9A961] mb-4">Quick Links</h4>
          <ul className="space-y-2.5 columns-2 md:columns-1 lg:columns-2">
            {FLINKS.map((l) => (
              <li key={l.label} className="break-inside-avoid">
                <Link
                  to={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-sm text-white/75 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-[0.15em] text-[#C9A961] mb-4">Contact</h4>
          <ul className="space-y-2.5 text-sm text-white/75">
            <li>
              <a href={`tel:${CONTACT.phoneTel}`} className="inline-flex items-center gap-2 hover:text-white transition-colors">
                <Phone size={14} className="text-[#C9A961]" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 hover:text-white transition-colors">
                <Mail size={14} className="text-[#C9A961]" /> {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-white/10 text-xs text-white/50 leading-relaxed space-y-2">
        <p>© {new Date().getFullYear()} Wallstreet Realty. All rights reserved. {CONTACT.dre}.</p>
        <p>
          Wallstreet Realty is a real estate and mortgage brokerage serving Southern California.
          All information is deemed reliable but not guaranteed and should be independently
          verified. This site is for informational purposes only and does not constitute an offer,
          solicitation, or financial advice. Equal Housing Opportunity.
        </p>
        <p>
          IDX listing data provided through iHomeFinder. Listings are subject to
          change without notice.
        </p>
      </div>
    </div>
  </footer>
);
